import { useUserProfile } from '~/services/useUserProfileQuery';
import { SCHOOL_ADMIN_ROLE } from '~/services/types';

import { AdministratorSetupPage } from './AdministratorSetupPage';
import { TeacherSetupPage } from './TeacherSetupPage';

export function SetupPage() {
  const { activeRole } = useUserProfile();

  // Administrators get a single-step setup form instead of the teacher wizard.
  if (activeRole === SCHOOL_ADMIN_ROLE) {
    return <AdministratorSetupPage />;
  }

  return <TeacherSetupPage />;
}
